var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPrinter = function SvgIconPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 10.875a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2.75a1 1 0 0 0-1 1V6.5h-.753C2.88 6.5 1.625 7.55 1.625 9v7.5a1 1 0 0 0 1 1H5v3.125a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V17.5h2.375a1 1 0 0 0 1-1V9c0-1.45-1.255-2.5-2.622-2.5H19V3.75a1 1 0 0 0-1-1zM17 6.5H7V4.75h10zm-13.375 9H5v-.875a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.875h1.375V9c0-.2-.208-.5-.622-.5H4.247c-.414 0-.622.3-.622.5zM17 15.625v4H7v-4z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconPrinter;